import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Modal,
  TextField,
  Tabs,
  Tab,
  useTheme,
  Pagination,
  PaginationItem,
  InputAdornment,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Tooltip,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material';
import { PlayArrow, MoreVert, ArrowBack, GridView, TableView } from '@mui/icons-material';
import live from 'packages/novous_web/src/assets/icons/Live.svg';
import call from 'packages/novous_web/src/assets/icons/phone-calling.svg';
import clone from 'packages/novous_web/src/assets/icons/Clone.svg';
import reverse from 'packages/novous_web/src/assets/icons/Fast Backward.svg';
import map from 'packages/novous_web/src/assets/icons/Map Stroke.svg';
import share from 'packages/novous_web/src/assets/icons/Share.svg';
import add from 'packages/novous_web/src/assets/icons/add.svg';
import eye from 'packages/novous_web/src/assets/icons/Eye.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import comment from 'packages/novous_web/src/assets/icons/Comment.svg';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import AlertToast from '../../../../../common/components/Alert';
import LiveFeedModal from '../../../Reports/components/LiveFeed';
import axiosInstance from '../../../../../api/apiClient';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import DateRangeFilter from 'packages/novous_web/src/common/components/DateRange';
import calendar from 'packages/novous_web/src/assets/icons/calendar.svg';
import arrow from 'packages/novous_web/src/assets/icons/Arrow.svg';
import { getWarningIcon } from '../helper/warningIcons';
import {
  MaterialReactTable,
  MRT_Cell,
  MRT_ColumnDef,
  MRT_TableOptions,
  useMaterialReactTable,
} from 'material-react-table';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import ShareFootageModal from 'packages/novous_web/src/common/components/ShareFootageModal';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import infoIcon from '../../../../../assets/icons/i.svg';
import AlertIcon from '../../../../../assets/icons/Alarm.svg';
import FilterDataModel from 'packages/novous_web/src/common/components/FilterDataModal';
import { set } from 'react-datepicker/dist/date_utils';

const pageSize = 100;
interface Alert {
  id: string;
  driverName: string;
  employeeId?: string | null;
  vehicleNumber: string;
  device_id: string;
  vehicleId: string;
  date_time: string;
  vehicleName: string;
  warningSortKey: string;
  videoUrls: string[];
  warningType: string;
  driverId: string;
  videoFileName: string;
  warningString: string;
  gpsSpeed: number;
  deviceType?: string;
  tripId?: string;
  markWarningStatus?: string;
}
interface WarningData {
  warningName: string;
  alerts: Alert[];
}
interface AlertsGridProps {
  alerts?: Alert[];
  calledFromDriverAlerts?: boolean;
}

const dateTimeStyles = {
  fontFamily: '"Inter Tight", sans-serif',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0%',
  color: '#767676',
};
type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

const AlertsGrid: React.FC<AlertsGridProps> = () => {
  const heading = 'Share Footage';
  const subheading = 'Enter an email address to share this Footage';
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const warningName = params.get('warningName');
  const isCritical = params.get('isCritical') === 'true';
  const oldViewMode = params.get('viewMode');
  const groupFilter = params.get('depotName') || '';
  const vehicleFilter = params.get('vehicleId') || '';
  const calledFromDriverAlerts = location?.state?.calledFromDriverAlerts || false;
  const calledFromDashboard = location?.state?.calledFromDashboard || false;
  const calledFromRunningHistory = location?.state?.calledFromRunningHistory || false;
  const driverId = location?.state?.driverId || '';
  const vehicleDataFromState = location?.state?.vehicleId || '';

  // Get duration filter from navigation state instead of URL parameters
  const originalState = location.state || {};
  const oldStartDate = originalState.startDate || '';
  const oldEndDate = originalState.endDate || '';
  const oldSelectedDuration = originalState.selectedDuration || 'Today';
  const { user } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState<Alert[]>([]);
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const theme = useTheme();
  const navigate = useNavigate();
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [isLiveFeedOpen, setIsLiveFeedOpen] = useState({
    isOpen: false,
    tripId: '',
    vehicleId: '',
    deviceId: '',
    deviceType: '',
  });
  const [newData, setNewData] = useState<WarningData[]>([]);
  const [alertLoading, setLoading] = useState(false);
  const [alertError, setError] = useState<string | null>(null);
  const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(null);
  const [lek, setLek] = useState<any>(null);
  const [filter, setFilter] = useState<any>();
  const [isFilterModel, setIsFilterModelOpen] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [viewMode, setViewMode] = useState<any>(oldViewMode);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [warningStatus, setWarningStatus] = useState<boolean | null>(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [startDate, setStartDate] = useState(oldStartDate || '');
  const [endDate, setEndDate] = useState(oldEndDate || '');
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const dateRangeArr = ['Today', 'Yesterday', '7 Days', '15 Days', '30 Days', 'Custom Range'];
  const [columnObj, setColumnObj] = useState<ColumnObjType>({
    date_time: { name: 'Date and Time', status: true },
    vehicleId: { name: 'Vehicle Reg No', status: true },
    actions: { name: 'Actions', status: true },
    gpsSpeed: { name: 'Last Received Speed', status: true },
  });
  const handleFilterClose = () => setIsFilterModelOpen(false);
  const [selectedDuration, setSelectedDuration] = useState(oldSelectedDuration || dateRangeArr[0]);
  const [liveFeedCameraInfo, setLiveFeedCameraInfo] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const currentFetchPage = useRef(1);
  const [fetchMore, setFetchMore] = useState<any>(false);
  const { data, error, loading, fetchData } = useAxios<any>(
    API_ENDPOINTS.alarm.VEHICLE_ALERT_COMMENT,
    'POST',
  );
  const { data: alertsData, fetchData: fetchAlertsData } = useAxios<any>(
    `${
      calledFromDriverAlerts && driverId
        ? API_ENDPOINTS.alarm.DRIVER_PAGINATED_ALERT_BY_WARNING
        : API_ENDPOINTS.alarm.VEHICLE_PAGINATED_ALERT_BY_WARNING
    }`,
    'POST',
  );

  const { data: updateWarningStatusData, fetchData: updateWarningStatusFetch } = useAxios<any>(
    API_ENDPOINTS.alarm.UPDATE_WARNING_STATUS,
    'POST',
  );

  const [selected, setSelected] = useState(2);
  const [currentPage, setCurrentPage] = useState(1);
  const paginatedArr = useRef<any[]>([null]);
  const totalPages = paginatedArr.current.length;
  const validateEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const [displayViewMore, setDisplayViewMore] = useState(false);
  const getDriverDisplayLabel = (alert: Alert) => {
    const employeeId = alert?.employeeId?.trim();
    if (employeeId) return employeeId;

    const driverName = alert?.driverName?.trim();
    if (driverName && driverName.toUpperCase() !== 'NA') return driverName;

    return `DRI${alert.vehicleId.slice(-4)}`;
  };

  useEffect(() => {
    if (oldEndDate && oldStartDate) {
      setStartDate(oldStartDate || '');
      setEndDate(oldEndDate || '');
    }
  }, [oldStartDate, oldEndDate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlGroup = params.get('depotName');
    const urlVehicle = params.get('vehicleId');

    if (urlGroup || urlVehicle) {
      setFilter({
        group: urlGroup || undefined,
        vehicle: urlVehicle || undefined,
      });
    }
  }, []);

  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    if (page !== 1) {
      setLoading(true);
      fetchAlertsData({
        fleetId: user?.customer_id,
        lastEvaluatedKey: paginatedArr.current[page - 1],
        warningType: warningName,
        startDate: startDate,
        endDate: endDate,
        ...(calledFromDriverAlerts && { driverId: driverId }),
        ...((filter?.group || groupFilter) && {
          vehicleGroup: filter?.group ?? groupFilter,
        }),
        ...((filter?.vehicle || vehicleFilter) && {
          vehicleId: filter?.vehicle ?? vehicleFilter,
        }),
      });
    } else {
      setLoading(true);
      fetchAlertsData({
        fleetId: user?.customer_id,
        lastEvaluatedKey: null,
        warningType: warningName,
        startDate: startDate,
        endDate: endDate,
        ...(calledFromDriverAlerts && { driverId: driverId }),
        ...((filter?.group || groupFilter) && {
          vehicleGroup: filter?.group ?? groupFilter,
        }),
        ...((filter?.vehicle || vehicleFilter) && {
          vehicleId: filter?.vehicle ?? vehicleFilter,
        }),
      });
    }
    setCurrentPage(page);
  };
  const handleLiveFeedClose = () => {
    setIsLiveFeedOpen({ isOpen: false, tripId: '', vehicleId: '', deviceId: '', deviceType: '' });
    setSelected(2);
    setLiveFeedCameraInfo([]);
  };
  useEffect(() => {
    const { startDate: newStartDate, endDate: newEndDate } = getDateRange(selectedDuration);
    if (newStartDate !== startDate || newEndDate !== endDate) {
      setStartDate(newStartDate);
      setEndDate(newEndDate);
    }
  }, [selectedDuration]);
  useEffect(() => {
    if (groupFilter) {
      setFilter((prev: any) => ({ ...prev, group: groupFilter }));
    }
    if (vehicleFilter) {
      setFilter((prev: any) => ({ ...prev, vehicleId: vehicleFilter }));
    }
    if (startDate && endDate) {
      setAlerts([]);
      setLoading(true);
      fetchAlertsData({
        fleetId: user?.customer_id,
        startDate: startDate,
        endDate: endDate,
        warningType: warningName,
        lastEvaluatedKey: null,
        ...(viewMode === 'grid' && { pageSize: pageSize }),
        ...(calledFromDriverAlerts && driverId && { driverId: driverId }),
        ...((filter?.group || groupFilter) && {
          vehicleGroup: filter?.group ?? groupFilter,
        }),
        ...((filter?.vehicle || vehicleFilter) && {
          vehicleId: filter?.vehicle ?? vehicleFilter,
        }),
      });
    }
  }, [startDate, endDate, selectedDuration, viewMode, groupFilter, vehicleFilter]);

  useEffect(() => {
    if (alertsData?.data?.actualWarningList) {
      if (viewMode === 'grid') {
        setLoading(false);
        setAlerts((prev) => [...prev, ...alertsData.data.actualWarningList]);
      } else {
        setLoading(false);
        setAlerts(alertsData.data.actualWarningList);
      }
      setTotalRecords(alertsData.data.totalRecords);
      if (alertsData.data.totalRecords >= pageSize) {
        setDisplayViewMore(true);
      }
    } else {
      setAlerts([]);
    }
    if (alertsData?.data?.lastEvaluatedKey) {
      if (paginatedArr.current.length === currentPage) {
        paginatedArr.current.push(alertsData.data.lastEvaluatedKey);
      }
      setLek(alertsData.data.lastEvaluatedKey);
    } else if (alertsData?.data?.lastEvaluatedKey === null && viewMode === 'grid') {
      setDisplayViewMore(false);
    }
  }, [alertsData]);
  const getDateRange = (range: string) => {
    if (range === 'Custom Range' && oldStartDate && oldEndDate) {
      return { startDate: oldStartDate, endDate: oldEndDate };
    }
    const today = dayjs();
    let startDate, endDate;

    switch (range) {
      case 'Today':
        startDate = today.format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case 'Yesterday':
        startDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        endDate = startDate;
        break;
      case '7 Days':
        startDate = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '15 Days':
        startDate = dayjs().subtract(14, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '30 Days':
        startDate = dayjs().subtract(29, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case 'Custom Range':
        // For custom range, we'll use the existing values if they exist
        return {
          startDate: today.format('YYYY-MM-DD'),
          endDate: today.format('YYYY-MM-DD'),
        };
      default:
        startDate = '';
        endDate = '';
    }
    return { startDate, endDate };
  };

  const [isCheckingVideos, setIsCheckingVideos] = useState(false);
  const handleOpenLiveFeed = async (
    vehicleId: string,
    videoUrls: string[],
    warningSortKey: string,
    warningType: string,
    videoFileName: string,
    deviceId: string,
    deviceType?: string,
    cameraKey?: string,
  ) => {
    setIsLiveFeedOpen({
      isOpen: true,
      tripId: vehicleId,
      vehicleId: vehicleId,
      deviceId: deviceId,
      deviceType: deviceType || '',
    });
    setIsCheckingVideos(true); // Start checking

    if (!videoFileName) {
      setLiveFeedCameraInfo([]);
      setIsCheckingVideos(false);
      return;
    }

    try {
      const response = await axiosInstance({
        url: API_ENDPOINTS.alarm.ALERTS_VIDE0_URL_SECONDARY,
        method: 'POST',
        data: {
          vehicleId: vehicleId,
          timestamp: warningSortKey.split('#')[1],
          alertType: warningType,
          fileNames: videoFileName,
          fleetId: user?.customer_id,
        },
        responseType: 'json',
      });

      const videoUrlsFromApi = Array.isArray(response.data.data) ? response.data.data : [];

      const cameraInfo = videoUrlsFromApi.map((url: string) => {
        const fileName = url.split('/').pop()?.split('?')[0] || '';
        const segments = fileName.split('_');
        const cameraCode = segments[1] || 'Unknown';
        const cameraMapping: Record<string, string> = {
          '01': 'ADAS',
          '02': 'CAM3',
          '03': 'CAM4',
          '04': 'DMS',
        };
        const arr = Object.entries(cameraMapping);
        const ck =
          cameraKey === 'FCW'
            ? 'ADAS'
            : cameraKey === 'DSM'
            ? 'CAM3'
            : cameraKey === 'REAR_CAMERA'
            ? 'CAM4'
            : cameraKey === 'IN_CABIN'
            ? 'DMS'
            : cameraKey;

        const cameraName = cameraMapping[cameraCode] || 'Unknown';
        return { cameraId: cameraCode, cameraName, playBackUrl: url };
      });

      setLiveFeedCameraInfo(cameraInfo);
      setSelected(0);
    } catch (error) {
      setLiveFeedCameraInfo([]);
      setIsCheckingVideos(false);
    }
  };
  const viewMenuData = [
    {
      name: 'View Details',
      icon: eye,
      click: () => navigate('/alarm/vehicle-alert-details', { state: alert }),
    },
    {
      name: 'Driver History',
      icon: call,
      click: () => {
        redirectToDriverHistory();
      },
    },
    {
      name: 'Trip Reconstruction',
      icon: reverse,
      click: () => {
        navigate(`/trips/reconstruction/${alert?.tripId}`, {
          state: { vehicleId: alert?.vehicleId, fromAlerts: true },
        });
      },
    },
    { name: 'Share Alert', icon: share, click: () => setOpenEmailModal(true) },
  ];
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [alert, setSelectedAlert] = useState<Alert | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };
  const [alertComment, setAlertComment] = useState<string>('');
  const [driverDialogOpen, setDriverDialogOpen] = useState<any>();
  const redirectToDriverHistory = () => {
    if (!alert?.driverId || alert?.driverId === 'NA') {
      setDriverDialogOpen(true);
      return;
    } else {
      navigate(`/directories/drivers/${alert?.driverId}`);
    }
  };
  const driverDialogClose = () => {
    setDriverDialogOpen(false);
  };
  const handleOpenMenu = (event: React.MouseEvent<HTMLSpanElement>, alertData: any) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedAlert(alertData);
    // Set the current warning status from alert data
    if (alertData?.markWarningStatus === null || alertData?.markWarningStatus === undefined) {
      setWarningStatus(null);
    } else {
      setWarningStatus(alertData.markWarningStatus === 'true' || alertData.markWarningStatus === true);
    }
  };
  const handleClose = () => {
    setModalOpen(false);
  };
  const handleCommentModalOpen = (alert: any) => {
    setSelectedAlert(alert);
    if (alert?.comment) {
      setAlertComment(alert?.comment);
    }
    setModalOpen(true);
  };
  const formatTimestamp = (timestamp: string) => {
    const [year, month, day, hour, minute, second] = timestamp?.split('_');
    const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
    return date
      .toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      })
      .replace(',', '');
  };
  const saveComment = () => {
    if (alertComment.trim() === '') {
      setAlertMessage('Please enter a comment');
      setAlertType('error');
      setAlertOpen(true);
      return;
    }
    fetchData({
      deviceId: alert?.device_id,
      comment: alertComment,
      sortKey: alert?.warningSortKey,
    });
    setModalOpen(false);
  };
  useEffect(() => {
    if (data?.status === 200) {
      setAlertMessage('Comment added successfully');
      setAlertType('success');
      setAlertOpen(true);
    }
  }, [data]);

  useEffect(() => {
    if (updateWarningStatusData?.status === 200) {
      setAlertMessage('Warning status updated successfully');
      setAlertType('success');
      setAlertOpen(true);

      // Update the alert in the local alerts array immediately
      if (alert?.warningSortKey) {
        setAlerts((prevAlerts) =>
          prevAlerts.map((a) =>
            a.warningSortKey === alert.warningSortKey
              ? { ...a, markWarningStatus: String(warningStatus) }
              : a,
          ),
        );

        // Update the selected alert object
        setSelectedAlert((prevAlert) =>
          prevAlert ? { ...prevAlert, markWarningStatus: String(warningStatus) } : prevAlert,
        );
      }

      handleCloseMenu();
    }
  }, [updateWarningStatusData]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setCalendarAnchorEl(event.currentTarget);
  };

  const handleCalendarClose = () => {
    setShowDatePicker(false);
    setCalendarAnchorEl(null);
  };
  const handleCalendarMenuClose = (value?: string) => {
    if (value) {
      // Only reset dates if changing FROM custom range TO another option
      if (selectedDuration === 'Custom Range' && value !== 'Custom Range') {
        const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
      }

      setSelectedDuration(value);
      setShowDatePicker(value === 'Custom Range');

      // If selecting Custom Range again, don't reset the dates - keep existing values
      if (value === 'Custom Range') {
        setCalendarAnchorEl(anchorEl); // Keep the anchor for the date picker
      }
    }

    setAnchorEl(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleShareClose = () => {
    setOpenEmailModal(false);
  };
  // Add this grouping function above your return statement
  const groupAlertsByDate = (alerts: Alert[]): Record<string, Alert[]> => {
    return alerts.reduce((acc: Record<string, Alert[]>, alert) => {
      const dateStr = alert.date_time.split('_').slice(0, 3).join('-');
      const date = new Date(dateStr.replace(/_/g, '-'));
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(alert);
      return acc;
    }, {});
  };

  const groupedAlerts = groupAlertsByDate(filteredData);
  useEffect(() => {
    const processData = (data: any[]) => {
      // Sort the data first
      const sorted = [...data].sort((a, b) => {
        const dateA = new Date(
          a.date_time.replace(/_/g, '-').replace(/(\d+)_(\d+)_(\d+)_(\d+)_(\d+)_(\d+)/, '$1-$2-$3T$4:$5:$6'),
        );
        const dateB = new Date(
          b.date_time.replace(/_/g, '-').replace(/(\d+)_(\d+)_(\d+)_(\d+)_(\d+)_(\d+)/, '$1-$2-$3T$4:$5:$6'),
        );
        return dateB.getTime() - dateA.getTime(); // Newest first
      });

      return sorted;
    };
    if (debouncedSearchQuery) {
      const filteredDataArr = alerts.filter(
        (alert: any) =>
          alert?.vehicleNumber?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          alert?.device_id?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          alert?.vehicleId?.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      if (viewMode === 'grid') {
        setFilteredData(processData(filteredDataArr));
      } else {
        setFilteredData(filteredDataArr);
      }
    } else {
      setFilteredData(processData(alerts));
    }
  }, [debouncedSearchQuery, alerts]);

  const columns: MRT_ColumnDef<Alert>[] = useMemo(
    () => [
      {
        accessorKey: 'date_time',
        header: 'Date and Time',
        Cell: ({ cell }: { cell: MRT_Cell<Alert> }) => {
          const value = cell.getValue<string>() || '';
          return (
            <Typography variant="body2" style={{ fontWeight: 400 }}>
              {formatTimestamp(value)}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'vehicleId',
        header: 'Vehicle Reg No',
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            color="tableSecondary"
            style={{ fontWeight: 400 }}
            className="px-2 py-1 bg-[#EAEEF4] rounded-md w-fit"
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'gpsSpeed',
        header: 'Last Received Speed',
        enableColumnActions: false,
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<number>()} km/h
          </Typography>
        ),
      },
      {
        accessorKey: 'actions',
        header: 'Actions',
        Cell: ({ row }) => (
          <>
            <IconButton
              sx={{ padding: 0 }}
              onClick={() => navigate('/alarm/vehicle-alert-details', { state: row.original })}
            >
              <img src={eye} alt="custom action" className="w-6 h-6" />
            </IconButton>
            <IconButton
              size="small"
              onClick={(event: any) => handleOpenMenu(event, row.original)}
              sx={{ p: 0 }}
            >
              <MoreVert fontSize="small" />
            </IconButton>
          </>
        ),
      },
    ],
    [],
  );
  const alertColumns: MRT_ColumnDef<Alert>[] = useMemo(() => {
    return columns.filter((column) => {
      const key = column.accessorKey as keyof ColumnObjType;
      return columnObj[key]?.status;
    });
  }, [columns, columnObj]);
  const tableOptions: MRT_TableOptions<Alert> = {
    columns: alertColumns,
    data: filteredData,
    enableColumnActions: false,
    enablePagination: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableFullScreenToggle: false,
    enableColumnResizing: false,
    enableToolbarInternalActions: false,
    muiTableBodyProps: {
      sx: {
        padding: 0,
        margin: 0,
        maxHeight: '300px',
        overflowY: 'auto',
      },
    },
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: theme.palette.mode === 'dark' ? '#000' : '#F0EFF8', // Black in dark mode, light color in light mode
        color: theme.palette.mode === 'dark' ? '#fff' : '#000', // White text in dark mode, black in light mode
        fontWeight: 'bold',
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        backgroundColor:
          row.index % 2 === 0
            ? theme.palette.mode === 'dark'
              ? '#121212' // a darker shade for even rows in dark mode
              : '#F0EFF8'
            : 'inherit',
      },
    }),
  };
  const tableInstance = useMaterialReactTable(tableOptions);

  const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);

  const handleCustomiseModalOpen = (event: any) => {
    setIsCustomiseModalOpen(true);
  };
  const handleCustomiseModalClose = () => {
    setIsCustomiseModalOpen(false);
  };
  const handleReset = () => {};
  const handleFilterOpen = () => setIsFilterModelOpen(true);

  const handleFilterSave = (data: any) => {
    setFilter(data);
    setAlerts([]);
    setLoading(true);

    // Don't update URL parameters - keep filters local to this page only
    fetchAlertsData({
      fleetId: user?.customer_id,
      startDate: startDate,
      endDate: endDate,
      warningType: warningName,
      lastEvaluatedKey: null,
      ...(calledFromDriverAlerts && { driverId: driverId }),
      ...(viewMode === 'grid' && { pageSize: pageSize }),
      ...(data.group && { vehicleGroup: data.group }),
      ...(data.vehicle && { vehicleId: data.vehicle }),
    });
  };

  const handleClearFilters = () => {
    setFilter({});
    setAlerts([]);
    setLoading(true);

    fetchAlertsData({
      fleetId: user?.customer_id,
      startDate: startDate,
      endDate: endDate,
      warningType: warningName,
      lastEvaluatedKey: null,
      ...(viewMode === 'grid' && { pageSize: pageSize }),
    });
  };

  const backNavigate = () => {
    if (calledFromDriverAlerts) {
      navigate(-1);
    } else if (calledFromDashboard) {
      navigate('/dashboard', { state: { startDate, endDate, selectedDuration, groupFilter, vehicleFilter } });
    } else if (calledFromRunningHistory) {
      // Navigate back to the previous page (Running History) using browser history
      navigate(-1);
    } else {
      // Get the original values from navigation state to restore them
      const originalState = location.state || {};
      const params = new URLSearchParams();

      // Only pass group and vehicle filters in URL (keep them persistent)
      if (groupFilter) {
        params.set('depotName', groupFilter);
      }
      if (vehicleFilter) {
        params.set('vehicleId', vehicleFilter);
      }
      const queryString = params.toString();
      navigate(`/alarm/vehicle-alerts${queryString ? `?${queryString}` : ''}`, {
        state: {
          // Restore original values from when we navigated to this page
          selectedDuration: originalState.selectedDuration,
          startDate: originalState.startDate,
          endDate: originalState.endDate,
          viewMode: originalState.viewMode,
        },
      });
    }
  };
  const fetchMoreRecords = (page: number) => {
    setFetchMore(true);
    currentFetchPage.current = page + 1;
    fetchAlertsData({
      fleetId: user?.customer_id,
      lastEvaluatedKey: lek ?? null,
      warningType: warningName,
      startDate: startDate,
      endDate: endDate,
      pageSize: pageSize,
      ...(calledFromDriverAlerts && { driverId: driverId }),
      ...((filter?.group || groupFilter) && { vehicleGroup: filter?.group ?? groupFilter }),
      ...((filter?.vehicle || vehicleFilter) && { vehicleId: filter?.vehicle ?? vehicleFilter }),
    });
    setFetchMore(false);
  };

  return (
    <>
      {alertLoading && (
        <div className="fixed inset-0 flex justify-center items-center bg-white bg-opacity-70 z-50">
          <CircularProgress />
        </div>
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          mb: 2, // Add some margin below the row
          mt: 4,
        }}
      >
        <button
          className="text-blue-600 font-medium flex items-center"
          onClick={backNavigate}
          style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          <ArrowBack className="mr-1" /> Back
        </button>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: { xs: 2, md: 0 },
          mb: 2, // Add some margin below the row
        }}
      >
        {/* Left Section: Icon and Warning Name */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontFamily: 'Inter Tight',
              color: 'text.primary',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <img src={getWarningIcon(warningName)} alt="Warning Icon" />
            <Typography
              variant="h6"
              className={`font-semibold ${warningName === 'SOS' ? 'text-red-500' : ''}`}
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 400,
                fontSize: { xs: '14px', md: '16px' },
                lineHeight: '18px',
                letterSpacing: '0%',
                textTransform: 'uppercase',
                color: warningName === 'SOS' ? 'red' : '#767676',
              }}
            >
              {warningName?.toUpperCase()}
            </Typography>
          </Typography>
          <Tooltip title={`Detailed information about ${warningName} alerts`} arrow placement="bottom">
            <img src={infoIcon} alt="info icon" title="More info" className="w-4 h-4 cursor-pointer" />
          </Tooltip>
          <Chip
            label={totalRecords || 0}
            size="small"
            sx={{
              width: 54,
              height: 24,
              gap: '10px',
              borderRadius: '4px',
              backgroundColor: '#EAE9F5',
              color: 'black',
            }}
          />
          <Box
            sx={{
              width: isCritical ? 57 : 100,
              height: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: isCritical ? '10px' : '4px',
              borderRadius: '8px',
              padding: '4px 8px',
              backgroundColor: isCritical ? '#F7E1E1' : '#FFF4E1',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '21px',
                letterSpacing: '0%',
                color: isCritical ? '#C83333' : '#A9861E',
              }}
            >
              {isCritical ? 'Critical' : 'Non Critical'}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          {/* Tabs */}
          {viewMode === 'table' && (
            <CustomIconButton
              icon={<img src={Custom} alt="Custom" width={16} height={16} />}
              text="Customize"
              background="transparent"
              outline={false}
              onClick={handleCustomiseModalOpen}
            />
          )}
          <Tabs
            value={viewMode}
            onChange={(e, newVal) => setViewMode(newVal)}
            sx={{
              borderRadius: '8px',
              padding: '4px',
              backgroundColor: theme.palette.selected,
              minWidth: 'fit-content',
            }}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            <Tab
              label=""
              value="grid"
              icon={<GridView />}
              iconPosition="start"
              sx={{
                ...(viewMode === 'grid'
                  ? {
                      backgroundColor: theme.palette.background.default,
                      color: theme.palette.primary.main,
                      borderRadius: '8px',
                      fontWeight: 600,
                      boxShadow: '0px 4px 6px #5547DD1A',
                    }
                  : { color: theme.palette.text.primary }),
              }}
            />
            <Tab
              label=""
              value="table"
              icon={<TableView />}
              iconPosition="start"
              sx={{
                ...(viewMode === 'table'
                  ? {
                      backgroundColor: theme.palette.background.default,
                      color: theme.palette.primary.main,
                      borderRadius: '8px',
                      fontWeight: 600,
                      boxShadow: '0px 4px 6px #5547DD1A',
                    }
                  : { color: theme.palette.text.primary }),
              }}
            />
          </Tabs>
        </Box>
        {/* Right Section: Tabs and Calendar Button */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
            width: { xs: '100%', md: 'auto' },
            justifyContent: { xs: 'flex-start', md: 'flex-end' },
          }}
        >
          {/* <div className="max-w-[400px]">
							<TextField
								variant="outlined"
								value={searchQuery}
								onChange={(e) => setSearchQuery(e.target.value)}
								placeholder="Search"
								sx={(theme) => ({
									"& .MuiOutlinedInput-root": {
										borderColor: theme.palette.action.selected,
										borderRadius: '8px',
										display: 'flex',
										alignItems: 'center',
										height: '100%', // Ensure it takes full available height
									},
									"& .MuiInputBase-root": {
										padding: '0rem 1rem'
									},
									"& .MuiOutlinedInput-input": {
										padding: '0px 12px', // Adjust padding for better spacing
										height: '48px',
										display: 'flex',
										alignItems: 'center',
									},
								})}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<img src={searchIcon} alt="icon" width={16} height={16} />
										</InputAdornment>
									),
									endAdornment: (
										<InputAdornment
											position="end"

											sx={(theme) => ({
												height: '48px', // Ensure full height
												maxHeight: '48px',
												display: 'flex',
												cursor: 'pointer',
												alignItems: 'center',
												borderLeft: `1px solid ${theme.palette.action.selected}`,
												paddingLeft: '8px',
											})}
										>
											<img src={filterIcon} onClick={handleFilterOpen} alt="icon" width={24} height={24} />
										</InputAdornment>
									),
								}}
								inputProps={{
									style: {
										display: 'flex',
										alignItems: 'center',
										fontSize: '14px', // You can adjust this as per Typography variant
										fontWeight: 500, // Normal text weight
									},
								}}
							/>
						</div> */}
          <Button
            variant="outlined"
            onClick={() => setIsFilterModelOpen(true)}
            startIcon={<img src={filterIcon} alt="Filter" width={24} height={24} />}
            sx={{
              height: { xs: '40px', md: '48px' },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              borderColor: '#5547dd',
              backgroundColor: 'white',
              color: '#5547dd',
              padding: { xs: '0 12px', md: '0 16px' },
              fontSize: { xs: '12px', md: '14px' },
              flexShrink: 0,
            }}
          >
            <span className="hidden sm:inline">Filter Data</span>
            <span className="sm:hidden">Filter</span>
          </Button>
          {/* Calendar Button */}
          {selectedDuration === 'Custom Range' && (
            <div className="flex items-center">
              <Box
                sx={(theme) => ({
                  backgroundColor: theme.palette.selected,
                  borderRadius: '8px',
                  padding: theme.spacing(1),
                })}
              >
                <Typography variant="subtitle2" className="truncate" sx={{ fontWeight: 700, marginRight: 1 }}>
                  Date Range:{' '}
                  <span style={{ color: '#235AF9' }}>
                    {startDate || oldStartDate} - {endDate || oldEndDate}
                  </span>
                </Typography>
              </Box>
            </div>
          )}
          <Button
            onClick={handleClick}
            variant="outlined"
            sx={{
              height: { xs: '40px', md: '48px' },
              px: { xs: 1, md: 2 },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 700,
              display: 'inline-flex',
              alignItems: 'center',
              gap: { xs: 0.5, md: 1 },
              borderColor: '#5547dd',
              backgroundColor: 'white',
              color: '#5547dd',
              minWidth: 0,
              maxWidth: '100%',
              flexShrink: 0,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <img src={calendar} alt="Calendar" width={18} height={18} />
              <Box sx={{ display: 'block', maxWidth: '100%' }}>
                <Typography
                  variant="body2"
                  sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {selectedDuration}
                </Typography>
              </Box>
              <img src={arrow} alt="Arrow" width={18} height={18} />
            </Box>
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => handleMenuClose()}
            PaperProps={{
              sx: {
                borderRadius: '8px',
                top: '10px',
                boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
            {dateRangeArr.map((label) => (
              <MenuItem
                key={label}
                onClick={() => handleCalendarMenuClose(label)}
                sx={(theme) => ({
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    backgroundColor: theme.palette.action.hover,
                  },
                  backgroundColor: selectedDuration === label ? theme.palette.selected : 'transparent',
                })}
              >
                <Typography variant="button" textTransform={'none'}>
                  {label}
                </Typography>
              </MenuItem>
            ))}
          </Menu>
          <Menu
            anchorEl={calendarAnchorEl}
            open={showDatePicker}
            onClose={handleCalendarClose}
            slotProps={{
              paper: {
                sx: {
                  borderRadius: '8px',
                  top: '10px',
                  padding: '0px',
                  boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
                },
              },
            }}
          >
            <DateRangeFilter
              onCancel={handleCalendarClose}
              onApply={(from, to) => {
                setStartDate(from);
                setEndDate(to);
                setSelectedDuration('Custom Range');
                setShowDatePicker(false);
                setCalendarAnchorEl(null);
              }}
              initialFrom={startDate}
              initialTo={endDate}
            />
          </Menu>
        </Box>
      </Box>
      <Box sx={{ width: '100%', overflow: 'hidden' }}>
        {Object.entries(groupAlertsByDate(filteredData)).map(([date, dateAlerts]) => (
          <Box sx={{ width: '100%', overflow: 'hidden' }}>
            {viewMode === 'grid' && (
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontFamily: 'Inter Tight',
                  color: 'text.secondary',
                  mb: 2,
                  pl: 2,
                  mt: 2,
                }}
              >
                {`${date} (${(dateAlerts as Alert[]).length})`}
              </Typography>
            )}
            {viewMode === 'grid' && (
              <Box className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 w-full overflow-hidden">
                {(dateAlerts as Alert[])?.map((alert) => (
                  <Card
                    key={alert.id}
                    sx={{
                      minWidth: { xs: 'auto', md: 'auto' },
                      maxWidth: { xs: '100%', md: 375.5 },
                      width: { xs: '100%', md: 'auto' },
                      minHeight: 81,
                      borderRadius: '12px',
                      border: '1px solid #F0EFF8',
                      boxShadow: 'none',
                      '&:hover': { boxShadow: 3 },
                      overflow: 'hidden',
                    }}
                    className="transition-shadow"
                  >
                    <CardContent
                      sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                        minWidth: 0,
                        overflow: 'hidden',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          width: '100%',
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Tooltip title={getDriverDisplayLabel(alert)} arrow>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontWeight: 500,
                                fontSize: '1rem', // Smaller font size
                                maxWidth: '100px', // Adjust width as needed
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {getDriverDisplayLabel(alert)}
                            </Typography>
                          </Tooltip>
                          <img
                            src={comment}
                            alt="comment"
                            style={{ width: 20, height: 20, cursor: 'pointer' }}
                            onClick={() => handleCommentModalOpen(alert)}
                          />
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <IconButton
                            size="small"
                            sx={{ color: '#5547DD', p: 0 }}
                            onClick={() =>
                              handleOpenLiveFeed(
                                alert.vehicleId,
                                alert.videoUrls,
                                alert.warningSortKey,
                                alert.warningString,
                                alert.videoFileName,
                                alert.device_id,
                                alert.deviceType,
                              )
                            }
                          >
                            <PlayArrow fontSize="medium" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={(event) => handleOpenMenu(event, alert)}
                            sx={{ p: 0 }}
                          >
                            <MoreVert fontSize="small" />
                          </IconButton>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                          flexWrap: { xs: 'wrap', md: 'nowrap' },
                          gap: { xs: 0.5, md: 2 },
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            color: 'text.secondary',
                            fontSize: { xs: '10px', md: '12px' },
                            minWidth: { xs: 'fit-content', md: 'auto' },
                          }}
                        >
                          {alert.vehicleId}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            color: 'text.secondary',
                            fontSize: { xs: '10px', md: '12px' },
                            minWidth: { xs: 'fit-content', md: 'auto' },
                          }}
                        >
                          {`${alert.gpsSpeed} Km/h`}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            ...dateTimeStyles,
                            fontSize: { xs: '10px', md: '12px' },
                            minWidth: { xs: 'fit-content', md: 'auto' },
                          }}
                        >
                          {formatTimestamp(alert?.date_time)}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            )}
            <Menu anchorEl={menuAnchorEl} open={Boolean(menuAnchorEl)} onClose={handleCloseMenu}>
              {viewMenuData.map((item, index) => (
                <MenuItem key={index} onClick={item.click}>
                  <div className="flex gap-2 mt-1">
                    <img src={item.icon} alt={item.name} style={{ marginRight: 8, width: 20, height: 20 }} />
                    <Typography variant="body2" fontWeight={600}>
                      {item.name}
                    </Typography>
                  </div>
                </MenuItem>
              ))}
              <MenuItem
                onClick={(e) => e.stopPropagation()}
                sx={{
                  px: 2,
                  py: 1,
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                  <img
                    src={AlertIcon}
                    alt="Warning Status"
                    style={{
                      width: 20,
                      height: 20,
                      filter:
                        'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(229deg) brightness(91%) contrast(101%)',
                    }}
                  />
                  <FormControl variant="standard" sx={{ minWidth: 140, flex: 1 }}>
                    <Select
                      id="warning-status-select"
                      value={warningStatus === null ? '' : warningStatus}
                      onChange={(e) => {
                        const value = e.target.value;
                        const newStatus = value === '' ? null : (value as boolean);
                        setWarningStatus(newStatus);

                        // Call API to update warning status only if not empty
                        if (newStatus !== null && alert?.device_id && alert?.warningSortKey) {
                          updateWarningStatusFetch({
                            deviceId: alert.device_id,
                            sortKey: alert.warningSortKey,
                            markWarningStatus: String(newStatus),
                          });
                        }
                      }}
                      disableUnderline
                      displayEmpty
                      sx={{
                        fontWeight: 600,
                        fontSize: '0.875rem',
                        '& .MuiSelect-select': {
                          padding: 0,
                          paddingRight: '24px !important',
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            borderRadius: '8px',
                            mt: 0.5,
                            boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
                            '& .MuiMenuItem-root': {
                              fontFamily: 'Inter Tight',
                              fontSize: '0.875rem',
                              fontWeight: 600,
                              padding: '10px 16px',
                              '&:hover': {
                                backgroundColor: '#F0EFF8',
                              },
                              '&.Mui-selected': {
                                backgroundColor: '#EAE9F5',
                                '&:hover': {
                                  backgroundColor: '#F0EFF8',
                                },
                              },
                            },
                          },
                        },
                      }}
                      renderValue={(value: any) => {
                        if (value === '' || value === null || value === undefined) {
                          return 'Warning Status:';
                        }
                        return `Warning Status: ${value ? 'True' : 'False'}`;
                      }}
                    >
                      <MenuItem value={true as any}>True</MenuItem>
                      <MenuItem value={false as any}>False</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </MenuItem>
            </Menu>
          </Box>
        ))}
        {viewMode === 'table' && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              width: '100%',
              height: '100%',
            }}
          >
            {/* Table */}
            <Box
              sx={{
                flex: 1,
                overflow: 'auto',
                border: '1px solid #F0EFF8',
                borderRadius: '12px',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
              }}
            >
              <MaterialReactTable table={tableInstance} />
            </Box>

            {/* Pagination */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 2,
              }}
            >
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                shape="rounded"
                color="primary"
                siblingCount={0}
                boundaryCount={0}
                renderItem={(item) => {
                  if (item.type === 'page' && item.page !== null && item.page > currentPage) {
                    return null;
                  }
                  return <PaginationItem {...item} />;
                }}
              />
            </Box>
          </Box>
        )}
      </Box>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="add-comment-modal"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            width: 560,
            height: 472,
            p: 4,
            borderRadius: '16px',
            border: '1px solid #F0EFF8',
            backgroundColor: 'background.paper',
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          {/* Header */}
          <Typography
            variant="h5"
            sx={{
              fontFamily: 'Inter Tight',
              fontWeight: 600,
              fontSize: '24px',
              lineHeight: '36px',
            }}
          >
            Add Comment
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontFamily: 'Inter Tight',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '24px',
              color: 'text.secondary',
            }}
          >
            Provide additional context or recommendations for this alert. Your comments will be logged for
            future reference and analysis.
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 'bold',
                fontSize: '16px',
                lineHeight: '24px',
                color: 'text.primary',
              }}
            >
              Comments
            </Typography>
            <TextField
              label="Write here"
              multiline
              rows={4}
              value={alertComment}
              onChange={(e) => setAlertComment(e.target.value)}
              variant="outlined"
              fullWidth
              InputLabelProps={{
                sx: {
                  fontFamily: 'Inter Tight',
                  fontWeight: 400,
                },
              }}
              InputProps={{
                sx: {
                  fontFamily: 'Inter Tight',
                  fontWeight: 400,
                },
              }}
            />
          </Box>

          {/* Buttons */}
          <Box sx={{ display: 'flex', gap: 2, mt: 'auto' }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 500,
                textTransform: 'none',
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => saveComment()}
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 500,
                textTransform: 'none',
                ml: 'auto',
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
      <AlertToast
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      {isLiveFeedOpen.isOpen && (
        <LiveFeedModal
          type="alert"
          alertName="Alert Evidence Video"
          selectedCamera={selected}
          trip={isLiveFeedOpen}
          cameraInfo={liveFeedCameraInfo}
          isDash={true}
          open={isLiveFeedOpen.isOpen}
          onClose={handleLiveFeedClose}
          deviceId={isLiveFeedOpen.deviceId}
          isCheckingVideos={isCheckingVideos}
          // deviceType={isLiveFeedOpen?.deviceType}
        />
      )}
      <ShareFootageModal
        open={openEmailModal}
        onClose={handleShareClose}
        existingVideos={alert?.videoUrls || []}
        videoFetchConfig={{
          endpoint: API_ENDPOINTS.alarm.ALERTS_VIDE0_URL_SECONDARY,
          method: 'POST',
          payload: {
            vehicleId: alert?.vehicleId,
            timestamp: alert?.warningSortKey?.split('#')[1],
            alertType: alert?.warningString,
            fileNames: alert?.videoFileName,
            fleetId: user?.customer_id,
          },
        }}
        emailConfig={{
          endpoint: API_ENDPOINTS.alarm.SHARE_ALERT_DETAILS_EMAIL,
          payload: {
            deviceId: alert?.device_id,
            warningSortKey: alert?.warningSortKey,
          },
        }}
        onVideoCopied={() => setOpenEmailModal(false)}
        onEmailSent={() => setOpenEmailModal(false)}
      />
      <CustomiseTableModal
        open={isCustomiseModalOpen}
        onClose={handleCustomiseModalClose}
        onReset={handleReset}
        title="Customize Your Table"
        description="Select and arrange table columns as you prefer."
        columnObj={columnObj}
        setColumnObj={setColumnObj}
      />
      <FilterDataModel
        open={isFilterModel}
        onClose={handleFilterClose}
        handleFilterSave={handleFilterSave}
        title="Filter"
        description="Use the options below to refine your search and find specific alerts quickly."
        showTripStatus={false}
        onReset={handleClearFilters}
        showClearButton={Boolean(filter?.group || filter?.vehicle)}
        initialFilters={{
          group: filter?.group ?? (groupFilter || null),
          vehicle: filter?.vehicle ?? (vehicleFilter || null),
        }}
        trgtcData={true}
      />
      <Dialog
        open={driverDialogOpen}
        onClose={driverDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Alert Message</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Driver not associated with this particular alert
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={driverDialogClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {displayViewMore && viewMode === 'grid' && (
        <Button onClick={() => fetchMoreRecords(currentPage)}>View More</Button>
      )}
    </>
  );
};

export default AlertsGrid;
